export default __webpack_public_path__ + "static/media/forma2.219732ce.svg";